import requests from "./httpService";

const SigninService = {
    adminLogin: async (body) => {
        return requests.post("/user/login", body);
    },
    clientLogin: async (body) => {
        return requests.post("/user/clientlogin", body);
    },
    adminOtpLogin: async (body) => {
        return requests.post("/user/verify/login", body);
    },
    verifyLoginAdmin: async (body) => {
        return requests.post(`/user/verify/login`, body);
    },
    adminResendOtp: async (body) => {
        return requests.post("/user/resend/otp", body);
    },
    superAdminLogin: async (body) => {
        return requests.post("/user/superlogin", body);
    },
}

export default SigninService; 